module.exports = __webpack_public_path__ + "static/media/nepPVGaurd.c9653a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nepPVGaurd.jpg
// module id = 1102
// module chunks = 0